import {dbitem}  from './dbItem'
import teras from './index'
//import filter from './filter'
var moment = require('moment')
var convert = require('xml-js')
var convertOpt = {compact:true,ignoreComment: true, spaces: 4}
/* TEST CON ANDREOLA BARBARA
EMAIL: barbaraandreola@yahoo.it
PWD: nd6418
*/

class contatto extends dbitem{
    constructor (args) {
        super()
        this.mysql.table = 'contatto'

        this._evento = {}
        this._fiscale= {}
        this._ecm = {}
        this.idencrypt = ''
        this._nextevento = {}
        return this
    }
    new(){
        return new Promise((resolve, reject) => {
            super.new().then(() => {
                this.row.password = Math.floor((Math.random() * 1000000) + 1)
                //this.row.giorno=moment().format('YYYY-MM-DD')
                resolve(true)
              })
        })
    }
    load(id){
        return new Promise((resolve, reject) => {
            super.load(id).then(() => {
                console.log('LOADED LOADED LOADED '+this.row.id)
                this.afterload().then(() => {
                    resolve(true)
                }).catch((error) => {
                    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ììì")
                    resolve(error)
                })
                //this.row.password = Math.floor((Math.random() * 1000000) + 1)
                //this.row.giorno=moment().format('YYYY-MM-DD')
                
              })
        })
    }
   checkEmail(emailCheck,id){
      return new Promise((resolve, reject) => {
         this.axios.query('fetchOne',`SELECT email FROM contatto WHERE email=→email AND id!=←id LIMIT 1`,{email:emailCheck,id:id}).then((response) => {
            var controllo = (response.result == emailCheck) ? false : true
            resolve(controllo)
         })
      })
   }
    afterRinnovo(societa){
        return new Promise((resolve, reject) => {
            var toLoad = 1
            this.axios.query('doQuery',`UPDATE statoiscrizione SET dbaction=1 WHERE contatto=←contatto AND societa=←societa AND dimesso=0 LIMIT 1`,{contatto: this.row.id,societa:societa}).then(() => {
                toLoad--
                if(toLoad==0)
                    resolve('afterRinnovo')
            })
        })
    }
    afterload(){          
        return new Promise((resolve, reject) => {
            //corso FAD se tipologiaformazione = 1 

            /*
            Modifica del 2019-06-07
            Abbiamo cambiato la logica per la verifica del evento ECM SI/NO da 
                IF(evn.ecmnumero !='',1,0) AS isecm,
            è diventata
                IF(evn.ecm = 1,1,0) AS isecm,
            */
            var toLoad = 5
            this.axios.query('fetchAll',`SELECT iscr.id AS id, iscr.contatto AS contatto,iscr.evento AS evento, 
            evn.titolo AS titolo, iniziail, finisceil, citta, respscientifico,idfad,
            tipologiaformazione,
            IF(NOW()>finisceil,1,0) AS finito,
            IF(NOW()>iniziail,1,0) AS iniziato,
            iscr.presente AS presente,
            IF(FIND_IN_SET(iscr.evento,'_2008'),1,0) AS badge,
            evn.attestatofreq AS attestatofreq,
            evn.crediti AS crediti,
            IF(evn.ecm = 1,1,0) AS isecm,
            evn.provider, provider.nome AS providernome, provider.numero AS providernumero, es.atti AS atti, 
            IF(es.urlaccesso!='',es.urlaccesso,linkcomplete) AS linkcomplete, es.urlaccesso AS urlaccesso

            FROM iscrizione AS iscr
            LEFT JOIN evento AS evn ON evn.id=iscr.evento
            LEFT JOIN eventosito AS es ON es.id=evn.id
            LEFT JOIN provider ON provider.id=evn.provider
            WHERE evn.annullato=0 AND iscr.contatto = →contatto AND iscr.stato=10
            ORDER BY finisceil DESC`,{contatto: this.row.id},this,'_evento').then((data) => {
                toLoad--
                if(toLoad==0)
                    resolve('eventi')
            })
            this.axios.query('fetchAll',`SELECT * FROM fiscale 
            LEFT JOIN iscrizione AS iscr ON iscr.id=fiscale.iscrizione 
            WHERE iscrizione >0 AND numero!='' AND fatturarea != 5  AND iscr.contatto = →contatto ORDER BY iscrizione,datadocumento DESC`,{contatto: this.row.id},this,'_fiscale').then(() => {
                toLoad--
                if(toLoad==0)
                    resolve('fiscale')
            })
            
            this.axios.query('fetchAll',`SELECT ecm.id AS id,iscr.id AS iscrizione, iscr.contatto AS contatto,iscr.evento AS evento
            ,evn.provider, provider.nome AS providernome, provider.numero AS providernumero
            ,ecm.disciplina AS disciplina,
            disciplina.nome AS disciplinanome,
            disciplina.nomeeng AS disciplinanomeeng,
            ecm.categoria AS categoria,
            categoria.nome AS categorianome,
            categoria.nomeeng AS categorianomeeng,

            evn.titolo AS titolo, iniziail,finisceil,citta,
            ecmnumero,evn.crediti,provider,
            evn.obiettivi AS obiettivi,
            obiettivi.nome AS obiettivinome,
            MAX(apprendimento.eseguitoil) AS datacrediti,
            evn.senzadomande
            FROM ecm
            LEFT JOIN apprendimento ON apprendimento.ecm = ecm.id
            LEFT JOIN iscrizione AS iscr ON iscr.id=ecm.iscrizione
            LEFT JOIN evento AS evn ON evn.id=iscr.evento
            LEFT JOIN categoria ON categoria.id=ecm.categoria 
            LEFT JOIN disciplina ON disciplina.id=ecm.disciplina 
            LEFT JOIN obiettivi ON obiettivi.id = evn.obiettivi 
            LEFT JOIN provider ON provider.id=evn.provider
            WHERE ecm.contatto = →contatto AND ecm.step=10
            GROUP BY ecm.id
            HAVING (YEAR(MAX(apprendimento.eseguitoil)) > 2019) OR (evn.senzadomande=1 AND YEAR(evn.finisceil)>2019)
            ORDER BY finisceil DESC`,{contatto: this.row.id},this,'_ecm').then(() => {
                toLoad--
                if(toLoad==0)
                    resolve('rinnovo')
            })
            this.axios.terasEncode(this.row.id).then((value) => {
                this.idencrypt = value
                toLoad--
                if(toLoad==0)
                    resolve('encode')
            })
            this.axios.query('fetchAll',`CALL evento_interesse_next(contatto_interesse(←contatto))`,{contatto: this.row.id},this,'_nextevento').then(() => {
                toLoad--
                if(toLoad==0)
                    resolve('fiscale')
            })
            
        })
    }


}


export default new contatto


// WEBPACK FOOTER //
// ./src/teras/contatto.js